import Vuex from 'vuex';
import Vue from 'vue';

import ApiService from "../../../js/modules/ApiService";

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        lots: [],
        lot: window.laravel.lot ?? [],
        cities: [],
        categories: [],
        filter: {
            city: 'all',
            category: 'all',
            sort: 'end_at',
            history: 'all'
        },
    },
    mutations: {
        setCities: (state, cities) => {
            state.cities = cities;
        },
        setCategories: (state, categories) => {
            state.categories = categories;
        },
        setLots: (state, lots) => {
            state.lots = lots;
        }
    },
    actions: {
        citiesList: ({commit}) => {
            new ApiService().get('/all-cities')
                .then((response) => {
                    commit('setCities', response.data);
                });
        },
        categoriesList: ({commit}) => {
            new ApiService().get('/all-lot-categories')
                .then((response) => {
                    commit('setCategories', response.data);
                });
        },
        getLots: ({state, commit}) => {
            new ApiService().post('/lots', {
                filter: state.filter,
            })
            .then((response) => {
                commit('setLots', response.data);
            });
        },
    },
});

